import { Routes } from '@angular/router';
import { AuthLayoutComponent } from '@egret/shared/components/layouts/auth-layout/auth-layout.component';
import { AdminLayoutComponent } from '@egret/shared/components/layouts/admin-layout/admin-layout.component';
import { LogoutComponent } from 'bookraw/views/sessions/logout/logout.component';
import { AuthGuard } from 'bookraw/shared/services/auth-guard';
import { MaintenanceComponent } from 'bookraw/views/maintenance/maintenance.component';

export const rootRouterConfig: Routes = [
  {
    path: '',
    redirectTo: 'sessions/signin',
    pathMatch: 'full'
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent,
    data: { title: 'Maintenance' }
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: { title: 'Logout' }
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'sessions',
        loadChildren: () => import('./views/sessions/sessions.module').then(m => m.SessionsModule),
        data: { title: 'Session' }
      },
      {
        path: '',
        canActivate: [ AuthGuard ],
        loadChildren: () => import('./views/partner-selector/partner-selector.module').then(m => m.PartnerSelectorModule),
        data: { title: 'Partner Selector' }
      },
      {
        path: '',
        canActivate: [ AuthGuard ],
        loadChildren: () => import('./views/school-selector/school-selector.module').then(m => m.SchoolSelectorModule),
        data: { title: 'School Selector' }
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [ AuthGuard ],
    children: [
      {
        path: 'books',
        loadChildren: () => import('./views/books/books.module').then(m => m.BooksModule),
        data: { title: 'menu.books', breadcrumb: 'menu.books' }
      },
      {
        path: 'flashcards',
        loadChildren: () => import('./views/flashcards/flashcards.module').then(m => m.FlashcardsModule),
        data: { title: 'menu.flashcards', breadcrumb: 'menu.flashcards' }
      },
      {
        path: 'songsandkaraoke',
        loadChildren: () => import('./views/karaokes/karaokes.module').then(m => m.KaraokesModule),
        data: { title: 'menu.songs_and_karaoke', breadcrumb: 'menu.songs_and_karaoke' }
      },
      {
        path: 'book-series',
        loadChildren: () => import('./views/book-series/book-series.module').then(m => m.BookSeriesModule),
        data: { title: 'menu.book_series', breadcrumb: 'menu.book_series' }
      },
      {
        path: 'scheduled-assigns',
        loadChildren: () => import('./views/book-assignments/book-assignments.module').then(m => m.BookAssignmentsModule),
        data: { title: 'menu.scheduled_assigns', breadcrumb: 'menu.scheduled_assigns' }
      },
      {
        path: 'playlists',
        loadChildren: () => import('./views/playlists/playlists.module').then(m => m.PlaylistsModule),
        data: { title: 'menu.playlists', breadcrumb: 'menu.playlists' }
      },
      {
        path: 'licenses',
        loadChildren: () => import('./views/licenses/licenses.module').then(m => m.LicensesModule),
        data: { title: 'menu.licenses', breadcrumb: 'menu.licenses' }
      },
      {
        path: 'manage-admins',
        loadChildren: () => import('./views/manage-admins/manage-admins.module').then(m => m.ManageAdminsModule),
        data: { title: 'menu.manage_admins', breadcrumb: 'menu.manage_admins' }
      },
      {
        path: '',
        loadChildren: () => import('./views/manage-users/manage-users.module').then(m => m.ManageUsersModule),
        data: { title: 'menu.manage_users', breadcrumb: 'menu.manage_users' }
      },
      {
        path: '',
        loadChildren: () => import('./views/my-profile/my-profile.module').then(m => m.MyProfileModule),
        data: { title: 'menu.my_profile', breadcrumb: 'menu.my_profile' }
      },
      {
        path: '',
        loadChildren: () => import('./views/statistics/statistics.module').then(m => m.StatisticsModule),
        data: { title: 'menu.statistics', breadcrumb: 'menu.statistics' }
      },
      {
        path: 'schools',
        loadChildren: () => import('./views/schools/schools.module').then(m => m.SchoolsModule),
        data: { title: 'menu.schools_and_organizations', breadcrumb: 'menu.schools_and_organizations' }
      },
      {
        path: 'partners',
        loadChildren: () => import('./views/partners/partners.module').then(m => m.PartnersModule),
        data: { title: 'Partners', breadcrumb: 'Partners' }
      },
      {
        path: 'school-statistics',
        loadChildren: () => import('./views/schools-statistics/schools-statistics.module').then(m => m.SchoolsStatisticsModule),
        data: { title: 'Statistics', breadcrumb: 'Statistics' }
      },
      {
        path: 'weekly-report',
        loadChildren: () => import('./views/weekly-report/weekly-report.module').then(m => m.WeeklyReportModule),
        data: { title: 'Weekly Report', breadcrumb: 'Weekly Report' }
      },
      {
        path: 'students',
        loadChildren: () => import('./views/students/students.module').then(m => m.StudentsModule),
        data: { title: 'Students', breadcrumb: 'Students' }
      },
      {
        path: 'teachers',
        loadChildren: () => import('./views/teachers/teachers.module').then(m => m.TeachersModule),
        data: { title: 'Teachers', breadcrumb: 'Teachers' }
      },
      {
        path: 'classes',
        loadChildren: () => import('./views/classes/classes.module').then(m => m.ClassesModule),
        data: { title: 'Classes', breadcrumb: 'Classes' }
      },
      {
        path: 'operators',
        loadChildren: () => import('./views/operators/operators.module').then(m => m.OperatorsModule),
        data: { title: 'Operators', breadcrumb: 'Operators' }
      },
      {
        path: 'partner-admins',
        loadChildren: () => import('./views/partner-admins/partner-admins.module').then(m => m.PartnerAdminsModule),
        data: { title: 'Partner Admins', breadcrumb: 'Partner Admins' }
      },
      {
        path: 'partner-users',
        loadChildren: () => import('./views/partner-users/partner-users.module').then(m => m.PartnerUsersModule),
        data: { title: 'Partner Admins', breadcrumb: 'Partner Admins' }
      },
      {
        path: 'avatars',
        loadChildren: () => import('./views/avatars/avatars.module').then(m => m.AvatarsModule),
        data: { title: 'Avatars', breadcrumb: 'Avatars' }
      },
      {
        path: 'badges',
        loadChildren: () => import('./views/badges/badges.module').then(m => m.BadgesModule),
        data: { title: 'Badges', breadcrumb: 'Badges' }
      },
      {
        path: 'taxonomies',
        loadChildren: () => import('./views/taxonomies/taxonomies.module').then(m => m.TaxonomiesModule),
        data: { title: 'Taxonomies', breadcrumb: 'Taxonomies' }
      },
      {
        path: 'taxonomy-terms',
        loadChildren: () => import('./views/taxonomy-terms/taxonomy-terms.module').then(m => m.TaxonomyTermsModule),
        data: { title: 'Taxonomy Terms', breadcrumb: 'Taxonomy Terms' }
      },
      {
        path: 'texts',
        loadChildren: () => import('./views/static-ui-texts/static-ui-texts.module').then(m => m.StaticUiTextsModule),
        data: { title: 'Static UI Texts', breadcrumb: 'Static UI Texts' }
      },
      {
        path: 'questionBank',
        loadChildren: () => import('./views/question-bank/question-bank.module').then(m => m.QuestionBankModule),
        data: { title: 'menu.question_bank', breadcrumb: 'menu.question_bank' }
      },
      {
        path: 'packages',
        loadChildren: () => import('./views/subscription-packages/subscription-packages.module').then(m => m.SubscriptionPackagesModule),
        data: { title: 'Subscription Packages', breadcrumb: 'Subscription Packages' }
      },
      {
        path: 'school-packages',
        loadChildren: () => import('./views/school-packages/school-packages.module').then(m => m.SchoolPackagesModule),
        data: { title: 'School Packages', breadcrumb: 'School Packages' }
      },
      {
        path: 'shelves',
        loadChildren: () => import('./views/shelves/shelves.module').then(m => m.ShelvesModule),
        data: { title: 'Shelves', breadcrumb: 'Shelves' }
      },
      {
        path: 'sso-settings',
        loadChildren: () => import('./views/sso-settings/sso-settings.module').then(m => m.SsoSettingsModule),
        data: { title: 'SSO Setup', breadcrumb: 'SSO Setup' }
      },
      {
        path: 'faq',
        loadChildren: () => import('./views/faqs/faqs.module').then(m => m.FaqsModule),
        data: { title: 'FAQ', breadcrumb: 'FAQ' }
      },
      {
        path: 'system',
        loadChildren: () => import('./views/configs/configs.module').then(m => m.ConfigsModule),
        data: { title: 'System', breadcrumb: 'System' }
      },
      {
        path: 'country-presets',
        loadChildren: () => import('./views/country-presets/country-presets.module').then(m => m.CountryPresetsModule),
        data: { title: 'Country Presets', breadcrumb: 'Country Presets' }
      },
      {
        path: 'support',
        loadChildren: () => import('./views/support-ai/support-ai.module').then(m => m.SupportAIModule),
        data: {title: 'Support AI', breadcrumb: 'Support AI'}
      },
      {
        path: '',
        loadChildren: () => import('./views/custom-page/custom-page.module').then(m => m.CustomPageModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'sessions/404'
  }
];
